import { Routes } from '@angular/router';
import { MainLayoutComponent } from './shared/components/layout/main-layout/main-layout.component';
import { HomeComponent } from './features/home/home.component';
import { UserMigrationComponent } from './features/user/components/user-migration/user-migration.component';
import { UserMigrationDetailComponent } from './features/user/components/user-migration-detail/user-migration-detail.component';
import { UserEditorComponent } from './features/user/components/user-editor/user-editor.component';
import { UserActivityComponent } from './features/user/components/user-activity/user-activity.component';
import { UserListComponent } from './features/user/components/user-list/user-list.component';
import { UnitListPageComponent } from './features/units/pages/unit-list-page.component';
import { DivineServicesListComponent } from './features/divine-services/pages/divine-services-list/divine-services-list.component';
import { DivineServiceHomePageComponent } from './features/divine-services/pages/divine-service-home-page/divine-service-home-page.component';
import { DivineServiceEditComponent } from './features/divine-services/pages/divine-service-edit/divine-service-edit.component';
import { UnitHomePageComponent } from './features/units/pages/unit-home-page.component';
import { UnitStartPageComponent } from './features/units/pages/unit-start-page.component';
import { UnitBirthdaysPageComponent } from './features/units/pages/unit-birthdays-page.component';
import { UnitAgendaPageComponent } from './features/units/pages/unit-agenda-page.component';
import { UnitLatestDivineServicePageComponent } from './features/units/pages/unit-latest-divine-service-page.component';
import { UnitProfileShellPageComponent } from './features/units/pages/unit-profile-shell-page.component';
import { UnitEditPageComponent } from './features/units/pages/unit-edit-page.component';
import { UnitParentHistoryPageComponent } from './features/units/pages/unit-parent-history-page/unit-parent-history-page.component';
import { UnitCommunityInfoPageComponent } from './features/units/pages/unit-community-info-page.component';
import { UnitCommunitiesPageComponent } from './features/units/pages/unit-communities-page.component';
import { MinistryTransferRequestsPageComponent } from './features/units/pages/ministry-transfer-requests-page.component';
import { PersonHomePageComponent } from './features/people/pages/person-home-page.component';
import { PersonEditPageComponent } from './features/people/pages/person-edit-page.component';
import { PersonEventsPageComponent } from './features/people/pages/person-events-page.component';
import { PersonEventsShellPageComponent } from './features/people/pages/person-events-shell-page.component';
import { PersonProfileShellPageComponent } from './features/people/pages/person-profile-shell-page.component';
import { PersonEventEditorPageComponent } from './features/people/pages/person-event-editor-page.component';
import { PersonCommunityHistoryPageComponent } from './features/people/pages/person-community-history-page.component';
import { PersonFamilyRelationshipsPageComponent } from './features/people/pages/person-family-relationships-page.component';
import { canCreatePersonInAuthorizedCommunity } from './features/people/guards/authorized-community.guard';
import { UnitMembersPageComponent } from './features/units/pages/unit-members-page/unit-members-page.component';
import { UnitMinistryBearersPageComponent } from './features/units/pages/unit-ministry-bearers-page.component';
import { canActivateFeedback } from './core/auth/feedback.guard';
import { canActivateAuth } from './core/auth/auth.guard';
import { canActivateAdmin } from './core/auth/admin.guard';
import { canActivateWithActivity } from './core/auth/activity.guard';
import { configurationRoutes } from './features/configuration/configuration.routes';
import { SessionExpiredPageComponent } from './core/auth/session-expired-page.component';
import { PermissionsReportComponent } from './features/user/components/permissions-report/permissions-report.component';
import { canActivatePermissionsReport } from './core/auth/permissions-report.guard';
import { canActivateManageMemberData } from './core/auth/manage-member-data.guard';
import { SpiritualAssistanceVisitsListComponent } from './features/spiritual-assistance-visits/spiritual-assistance-visits-list.component';
import {
  SpiritualAssistanceVisitCreateComponent,
} from './features/spiritual-assistance-visits/spiritual-assistance-visit-create.component';
import { MemberFollowUpPageComponent } from './features/member-follow-up/member-follow-up-page.component';

export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        component: HomeComponent,
        canActivate: [canActivateAuth]
      },
      {
        path: 'session-expired',
        component: SessionExpiredPageComponent
      },
      {
        path: 'profile',
        data: { breadcrumb: 'Mi perfil', selfProfile: true },
        canActivate: [canActivateAuth],
        component: UserEditorComponent
      },
      {
        path: 'feedback',
        canActivate: [canActivateAuth, canActivateFeedback],
        canActivateChild: [canActivateFeedback],
        data: { breadcrumb: 'Tareas' },
        children: [
          { path: '', loadComponent: () => import('./features/feedback/feedback-list-page.component').then(m => m.FeedbackListPageComponent) },
          { path: 'new', data: { breadcrumb: 'Nueva tarea' }, loadComponent: () => import('./features/feedback/feedback-detail-page.component').then(m => m.FeedbackDetailPageComponent) },
          { path: ':id', data: { breadcrumb: 'Detalle de la tarea' }, loadComponent: () => import('./features/feedback/feedback-detail-page.component').then(m => m.FeedbackDetailPageComponent) }
        ]
      },
      { path: 'permissions-report', data: { breadcrumb: 'Roles y permisos' }, canActivate: [canActivateAuth, canActivatePermissionsReport], component: PermissionsReportComponent },
      {
        path: 'users',
        data: { breadcrumb: 'Usuarios' },
        canActivate: [canActivateAuth, canActivateAdmin],
        children: [
          {
            path: '',
            component: UserListComponent
          },
          {
            path: 'new',
            data: { breadcrumb: 'Nuevo usuario' },
            component: UserEditorComponent
          },
          {
            path: 'migration',
            data: { breadcrumb: 'Migración de usuarios' },
            children: [
              {
                path: '',
                component: UserMigrationComponent
              },
              {
                path: ':email',
                data: { breadcrumb: '' },
                component: UserMigrationDetailComponent
              }
            ]
          },
          {
            path: ':id/activity',
            data: { breadcrumb: 'Actividad' },
            component: UserActivityComponent
          },
          {
            path: ':id',
            data: { breadcrumb: '' },
            component: UserEditorComponent
          },
          {
            path: ':id/edit',
            redirectTo: ':id',
            pathMatch: 'full'
          }
        ]
      },
      {
        path: 'units',
        data: { breadcrumb: 'Comunidades' },
        canActivate: [canActivateAuth],
        children: [
          {
            path: '',
            component: UnitListPageComponent
          },
          {
            path: 'new',
            data: { breadcrumb: 'Nueva comunidad' },
            canActivate: [canActivateWithActivity],
            component: UnitEditPageComponent
          },
          {
            path: 'ministry-transfer-requests',
            data: { breadcrumb: 'Pases ministeriales' },
            canActivate: [canActivateWithActivity],
            component: MinistryTransferRequestsPageComponent
          },
          {
            path: ':unit-id',
            data: { breadcrumb: '' },
            children: [
              {
                path: '',
                component: UnitProfileShellPageComponent,
                children: [
                  { path: '', component: UnitStartPageComponent },
                  { path: 'summary', data: { breadcrumb: 'Atención espiritual' }, component: UnitHomePageComponent },
                  { path: 'birthdays', data: { breadcrumb: 'Cumpleaños' }, canActivate: [canActivateWithActivity], component: UnitBirthdaysPageComponent },
                  { path: 'agenda', data: { breadcrumb: 'Agenda' }, canActivate: [canActivateWithActivity], component: UnitAgendaPageComponent },
                  { path: 'latest-divine-service', data: { breadcrumb: 'Último SD' }, canActivate: [canActivateWithActivity], component: UnitLatestDivineServicePageComponent },
                  { path: 'info', data: { breadcrumb: 'Datos de la comunidad' }, component: UnitCommunityInfoPageComponent },
                  {
                    path: 'members',
                    data: { breadcrumb: 'Miembros' },
                    canActivate: [canActivateWithActivity],
                    component: UnitMembersPageComponent,
                  },
                  {
                    path: 'ministry-bearers',
                    data: { breadcrumb: 'Portadores de ministerio' },
                    canActivate: [canActivateWithActivity],
                    component: UnitMinistryBearersPageComponent,
                  },
                  {
                    path: 'events',
                    pathMatch: 'full',
                    redirectTo: 'info',
                  },
                  {
                    path: 'spiritual-assistance-visits',
                    data: { breadcrumb: 'VAEs' },
                    canActivate: [canActivateAuth, canActivateWithActivity],
                    children: [
                      { path: '', component: SpiritualAssistanceVisitsListComponent },
                      { path: 'new', data: { breadcrumb: 'Registrar VAE' }, component: SpiritualAssistanceVisitCreateComponent },
                      { path: ':visit-id/edit', data: { breadcrumb: 'Editar VAE' }, component: SpiritualAssistanceVisitCreateComponent },
                    ],
                  },
                  {
                    path: 'divine-services',
                    data: { breadcrumb: 'Servicios divinos' },
                    canActivate: [canActivateAuth, canActivateWithActivity],
                    children: [
                      { path: '', component: DivineServicesListComponent },
                      { path: 'new', data: { breadcrumb: 'Nuevo servicio' }, component: DivineServiceEditComponent },
                      {
                        path: ':divine-service-id',
                        data: { breadcrumb: '' },
                        children: [
                          { path: '', component: DivineServiceHomePageComponent },
                          { path: 'edit', data: { breadcrumb: 'Editar servicio' }, component: DivineServiceEditComponent },
                        ],
                      },
                    ],
                  },
                  {
                    path: 'communities',
                    data: { breadcrumb: 'Comunidades' },
                    component: UnitCommunitiesPageComponent,
                  },
                  { path: 'schedules', pathMatch: 'full', redirectTo: '' },
                  {
                    path: 'parent-history',
                    data: { breadcrumb: 'Historial de pertenencia' },
                    component: UnitParentHistoryPageComponent,
                  },
                ],
              },
              {
                path: 'edit',
                data: { breadcrumb: 'Editar' },
                canActivate: [canActivateWithActivity],
                component: UnitEditPageComponent
              },
              {
                path: 'member-follow-up',
                data: { breadcrumb: 'Seguimiento AE' },
                canActivate: [canActivateWithActivity],
                component: MemberFollowUpPageComponent,
              },
              {
                path: 'members/:person-id',
                data: { breadcrumb: '' },
                canActivate: [canActivateWithActivity],
                children: [
                  {
                    path: '',
                    component: PersonProfileShellPageComponent,
                    children: [
                      { path: '', component: PersonHomePageComponent },
                      {
                        path: 'events',
                        data: { breadcrumb: 'Eventos' },
                        canActivate: [canActivateWithActivity],
                        component: PersonEventsShellPageComponent,
                        children: [
                          { path: '', component: PersonEventsPageComponent },
                          { path: 'new/:kind', data: { breadcrumb: 'Nuevo evento' }, component: PersonEventEditorPageComponent },
                          { path: ':kind/:event-id/edit', data: { breadcrumb: 'Editar evento' }, component: PersonEventEditorPageComponent },
                        ]
                      },
                      { path: 'family-relationships', data: { breadcrumb: 'Vínculos familiares' }, canActivate: [canActivateManageMemberData], component: PersonFamilyRelationshipsPageComponent },
                      { path: 'community-history', data: { breadcrumb: 'Historial de comunidad' }, component: PersonCommunityHistoryPageComponent },
                    ],
                  },
                  {
                    path: 'edit',
                    data: { breadcrumb: 'Editar' },
                    canActivate: [canActivateManageMemberData],
                    component: PersonEditPageComponent
                  },
                ]
              },
            ]
          }
        ]
      },
      {
        path: 'people',
        data: { breadcrumb: 'Personas' },
        canActivate: [canActivateAuth],
        children: [
          {
            path: '',
            redirectTo: '/',
            pathMatch: 'full'
          },
          {
            path: 'new',
            data: { breadcrumb: 'Nuevo miembro' },
            canActivate: [canActivateManageMemberData, canCreatePersonInAuthorizedCommunity],
            component: PersonEditPageComponent
          },
          {
            path: ':person-id',
            data: { breadcrumb: '' },
            children: [
              {
                path: '',
                component: PersonProfileShellPageComponent,
                children: [
                  { path: '', component: PersonHomePageComponent },
                  {
                    path: 'events',
                    data: { breadcrumb: 'Eventos' },
                    canActivate: [canActivateWithActivity],
                    component: PersonEventsShellPageComponent,
                    children: [
                      { path: '', component: PersonEventsPageComponent },
                      { path: 'new/:kind', data: { breadcrumb: 'Nuevo evento' }, component: PersonEventEditorPageComponent },
                      { path: ':kind/:event-id/edit', data: { breadcrumb: 'Editar evento' }, component: PersonEventEditorPageComponent },
                    ]
                  },
                  { path: 'family-relationships', data: { breadcrumb: 'Vínculos familiares' }, canActivate: [canActivateManageMemberData], component: PersonFamilyRelationshipsPageComponent },
                  { path: 'community-history', data: { breadcrumb: 'Historial de comunidad' }, canActivate: [canActivateWithActivity], component: PersonCommunityHistoryPageComponent },
                ],
              },
              {
                path: 'edit',
                data: { breadcrumb: 'Editar' },
                canActivate: [canActivateManageMemberData],
                component: PersonEditPageComponent
              },
            ]
          }
        ]
      },
      {
        path: 'configuration',
        data: { breadcrumb: 'Configuración' },
        canActivate: [canActivateAuth, canActivateAdmin],
        children: configurationRoutes
      },
      {
        path: '**',
        redirectTo: ''
      }
    ]
  }
];
